import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import _ from "lodash";

import * as actions from "../../../../../actions/project.actions";
import * as adminActions from "../../../../../actions/admin.actions";
import * as commonActions from "../../../../../actions/common.actions";

import MatchesTable from "../components/AdminProjectMatchesTable";

import parseAdvancedSearch from "../../../../../utils/parseAdvancedSearch";
import parseFilters from "../../../../../utils/parseFilters";
import {
  decodeSearchParams,
  getFinalQueryString
} from "../../../../../utils/parseQueries";

const header = notifySelectedMatches => ({
  color: "strongGrey",
  title: "Match & Notify",
  text: `Please click on match and notify to match members and send notifications.`,
  buttons: [
    {
      text: "Match & Notify",
      color: "blue",
      onClick: notifySelectedMatches
    }
  ]
});

const approvedSubHeader = (projectId, totalMatches, totalPitches) => {
  return {
    items: [
      {
        caption: "Project Detail",
        url: `/admin/project/${projectId}/detail`
      },
      {
        caption: `Matches (${totalMatches})`,
        url: `/admin/project/${projectId}/matches`
      },
      {
        caption: `Pitches (${totalPitches})`,
        url: `/admin/project/${projectId}/pitches`
      },
      {
        caption: "SOW",
        url: `/admin/project/${projectId}/sow`
      },
      {
        caption: "Reviews",
        url: `/admin/project/${projectId}/reviews`
      }
    ],
    activeItem: 1
  };
};

class AdminProjectMatchesTableContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      advancedSearch: [],
      currentProjectState: null,
      filters: [],
      selection: []
    };

    this.getQuery = this.getQuery.bind(this);
    this.notifySelectedMatches = this.notifySelectedMatches.bind(this);
  }

  componentWillMount() {
    this.setState({ ...decodeSearchParams(this.props.location.search) });
  }

  componentDidMount() {
    const filters = this.getQuery();
    const projectId = this.props.match.params.projectId;

    this.props.adminActions.getProject(projectId);
    this.props.adminActions.getProjectMatches(projectId, filters);
    this.props.adminActions.getProjectMatchesCSVData(projectId, filters);
  }

  componentDidUpdate(prevProps, prevState) {
    this.setHeaderBar(prevState);
  }

  componentWillUnmount() {
    this.props.commonActions.setHeaderBar({});
    this.props.commonActions.setSubHeader({});
  }

  setHeaderBar(prevState) {
    const project = this.props.project;
    const status = _.get(project, "status.name");

    const totalMatches = _.get(project, "stats.matches.matched");
    const totalPitches =
      _.get(project, "stats.pitches.accepted") +
      _.get(project, "stats.pitches.pending");

    let headerBar = {};
    let subHeader = {};
    let currentProjectState = status;

    if (status != undefined) {
      headerBar = header(this.notifySelectedMatches);
      subHeader = approvedSubHeader(project.id, totalMatches, totalPitches);
    }

    if (currentProjectState !== prevState.currentProjectState) {
      this.props.commonActions.setHeaderBar(headerBar);
      this.props.commonActions.setSubHeader(subHeader);
      this.setState({ currentProjectState });
    }
  }

  getQuery() {
    return getFinalQueryString(
      parseFilters(this.state.filters) +
        parseAdvancedSearch(this.state.advancedSearch)
    );
  }

  notifySelectedMatches() {
    const projectId = this.props.match.params.projectId;
    const selection = this.state.selection;
    const filters = this.getQuery();

    const payload = {
      project_id: projectId,
      status_id: 4,
      notify: selection,
      filters: filters
    };

    this.props.adminActions.notifyProjectMatches(payload);
  }

  onUpdateSelection = value => {
    this.setState({
      selection: value
    });
  };

  onUpdateFilters = value => {
    this.setState({
      filters: value
    });
  };

  render() {
    return (
      !_.isEmpty(this.props.project) && (
        <MatchesTable
          project={this.props.project}
          matches={this.props.matches.data || []}
          matches_csv={_.get(this.props, "matches_csv.data") || []}
          advancedSearch={this.state.advancedSearch}
          filters={this.state.filters}
          getCsvData={this.props.adminActions.getProjectMatchesCSVData}
          getTable={this.props.adminActions.getProjectMatches}
          history={this.props.history}
          loading={this.props.loading}
          numberOfPages={this.props.matches.last_page}
          page={this.props.page}
          paginationCount={this.props.paginationCount}
          setPage={this.props.adminActions.setPage}
          setSort={this.props.adminActions.setSort}
          sortData={this.props.sortData}
          onUpdateFilters={this.onUpdateFilters}
          onUpdateSelection={this.onUpdateSelection}
        />
      )
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.project.loadingGetProject,
    project: state.admin.project,
    matches: state.admin.matches,
    matches_csv: state.admin.matches_csv,
    page: state.admin.pagination.matches,
    paginationCount: adminActions.getPaginationCounts(state.admin.pagination),
    sortData: state.admin.sorting.matches
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch),
    adminActions: bindActionCreators(adminActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminProjectMatchesTableContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/project/matches/containers/AdminProjectMatchesContainer.js